<template functional>
	<span class="text-danger ml-1">*</span>
</template>

<script>
  export default {
    name: 'RequiredIcon',
  }
</script>
